/**
 * Format the clk value for the pgn.
 */
export function formatClk(timeValueDs: number) {
  const moveTimeM = Math.floor((timeValueDs % 36000) / 600);
  const moveTimeS = Math.floor((timeValueDs % 36000) % 600) / 10;

  return `${Math.floor(timeValueDs / 36000)}:${moveTimeM < 10 ? '0' : ''}${moveTimeM}:${moveTimeS < 10 ? '0' : ''}${moveTimeS}`;
}
